export function getMeta(name: string) {
  let el: Element | null = document.getElementsByTagName(name)[0]
  if (el) {
    return el.textContent || ''
  } else {
    el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`)
    return el?.getAttribute('content') || ''
  }
}
